// extracted by mini-css-extract-plugin
export default {"photo-input":"AppPhoto_photo-input__QdMN5","icon":"AppPhoto_icon__Djo+K"};